import { writable } from 'svelte/store';

export const iddistribuidor = writable(0);
export const nombre = writable(0);